import styled from 'styled-components/macro';
import HorizontalList from 'components/HorizontalList';
import scaleSize from 'utils/scale-size';
import PageTitle from 'components/PageTitle';

export const StyledProfileTitle = styled(PageTitle)`
  top: ${scaleSize(60)}px;
  left: ${scaleSize(220)}px;
  font-family: 'RobotoMedium', sans-serif;
`;

export const StyledProfileList = styled(HorizontalList)`
  margin-top: ${scaleSize(340)}px;
  margin-left: ${scaleSize(220)}px;
`;

export const StyledProfileSupportInfo = styled.div`
  position: absolute;
  bottom: ${scaleSize(90)}px;
  left: ${scaleSize(220)}px;
  font-family: 'RobotoRegular', sans-serif;
  font-weight: 500;
  letter-spacing: ${scaleSize(-0.21)}px;
  font-size: ${scaleSize(30)}px;
  vertical-align: top;

  & > div {
    height: ${scaleSize(40)}px;
    margin-bottom: ${scaleSize(32)}px;
    line-height: 1.33;
    color: ${({ theme }) => theme.secondaryTextColor};
  }

  & > span {
    color: ${({ theme }) => theme.mainTextColor};
    margin-right: ${scaleSize(40)}px;
  }
`;

export const StyledProfileVersion = styled.div`
  position: absolute;
  bottom: ${scaleSize(90)}px;
  right: ${scaleSize(90)}px;
  display: inline-block;
  font-family: 'RobotoRegular', sans-serif;
  font-weight: 500;
  letter-spacing: ${scaleSize(-0.21)}px;
  font-size: ${scaleSize(30)}px;
  vertical-align: top;

  &:first-child {
    margin-right: ${scaleSize(110)}px;
  }

  &:last-child {
    text-align: right;
  }

  & > div {
    height: ${scaleSize(40)}px;
    margin-bottom: ${scaleSize(32)}px;
    line-height: 1.33;
    color: ${({ theme }) => theme.secondaryTextColor};
  }

  & > span {
    color: ${({ theme }) => theme.mainTextColor};
    margin-right: ${scaleSize(40)}px;

    &:last-child {
      margin-right: 0;
    }
  }
`;
